<div class="channel-preview rounded-t-[14px]" [style.border]="!noBorder ? '1.5px solid #F4F4F4' : 'none'">
	<div class="content">
		<div class="header flex justify-center items-center py-2 bg-[#3b006c] rounded-t-[14px]">
			<label [style.color]="!isAppJotto ? 'var(--portals-theme-primary-text)' : 'var(--portals-theme-accent-text)'" class="uppercase tracking-[0.28px] mr-1 mt-0 ml-0 mb-0 font-bold text-[14px/41px] font-[Roboto]">follow with</label>
			<img class="w-[50px] h-auto" [src]="!isAppJotto ? projectImage : '/assets/images/jotto-accent.png'" />
		</div>
		<div class="main bg-portals-theme-preview-background py-2 px-4" fxLayout="column">
			<div class="title flex justify-center items-center mb-2.5" #title>
				<img [src]="channel?.image?.url || projectImage" class="bg-white rounded-[50%] w-7.5 h-7.5 mr-2" />
				<label class="text-[#f4f4f4] tracking-[0.13px] m-0 leading-none font-normal text-[23px/13px] font-[Roboto]">
					{{ channel.name }}
				</label>
			</div>
			<div id="qr-code-print" class="qr-code">
				<div style="position: relative; min-height: 270px">
					<div style="position: absolute">
						<qrcode #qrCode [qrdata]="channel.share_url" [allowEmptyString]="true" [cssClass]="'center'" [colorDark]="qrCodeColor.dark" [colorLight]="qrCodeColor.light" [errorCorrectionLevel]="'H'" elementType="svg" [scale]="1" [width]="'full'" [margin]="2"></qrcode>
					</div>
					<svg width="74" height="74" style="transform: translate(0%, 0%); width: 270px; height: 270px">
						<image [attr.href]="'/assets/images/jotto-yellow.svg'" width="74" height="74" style="transform: translate(93px, 93px)"></image>
					</svg>
				</div>
				<div style="display: none" #qrCodeContainer></div>
			</div>
			<div>
				<p class="font-light text-[13px/16px] font-[Roboto] mx-0 text-portals-theme-link-text">
					{{ channel.description }}
				</p>
			</div>
		</div>
		<div class="footer flex justify-center items-center py-2 bg-portals-primary-900 hover:cursor-pointer rounded-b-[14px]" *ngIf="channel.share_url">
			<a id="share-url-print" class="tracking-[0.28px] mr-1 font-light font-[Roboto] text-inherit" cdkCopyToClipboard="{{ channel.share_url }}" (click)="shareConfirm()" [style.color]="!isAppJotto ? 'var(--portals-theme-primary-text)' : 'var(--portals-theme-accent-text)'" [style.z-index]="10">
				{{ channel.share_url }}
			</a>
			<fa-icon cdkCopyToClipboard="{{ channel.share_url }}" (click)="shareConfirm()" [style.color]="!isAppJotto ? 'var(--portals-theme-primary-text)' : 'var(--portals-theme-accent-text)'" [style.cursor]="pointer" [style.z-index]="10" icon="link"></fa-icon>
		</div>
	</div>
	<div class="flex justify-evenly align-items-center p-2 cursor-pointer">
		<div class="item">
			<a class="flex align-items-center justify-center no-underline hover:cursor-pointer leading-none" (click)="shareConfirm()" cdkCopyToClipboard="{{ channel.share_url }}" [style.color]="drawer ? 'var(--portals-theme-primary-text)' : 'white'">
				<svg [ngClass]="{ 'text-portals-primary-900': drawer, 'text-white': !drawer }" class="w-4 h-4 cursor-pointer dark:text-white mr-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
					<path d="M14.419 10.581a3.564 3.564 0 0 0-2.574 1.1l-4.756-2.49a3.54 3.54 0 0 0 .072-.71 3.55 3.55 0 0 0-.043-.428L11.67 6.1a3.56 3.56 0 1 0-.831-2.265c.006.143.02.286.043.428L6.33 6.218a3.573 3.573 0 1 0-.175 4.743l4.756 2.491a3.58 3.58 0 1 0 3.508-2.871Z" />
				</svg>
				Share
			</a>
		</div>
		<div class="item">
			<a class="flex align-items-center justify-center no-underline hover:cursor-pointer leading-none" (click)="compositeAndDownload()" [style.color]="drawer ? 'var(--portals-theme-primary-text)' : 'white'">
				<mat-icon [style.color]="drawer ? 'var(--portals-theme-primary-text)' : 'white'" class="flex items-center text-[20px] cursor-pointer">save_alt</mat-icon>
				Download
			</a>
		</div>
		<div class="item">
			<a class="flex align-items-center justify-center no-underline hover:cursor-pointer leading-none" #feedIcon (click)="openDialog()" [style.color]="drawer ? 'var(--portals-theme-primary-text)' : 'white'">
				<!--				<mat-icon-->
				<!--					[style.color]="-->
				<!--						drawer ? 'var(--portals-theme-primary-text)' : 'white'-->
				<!--					"-->
				<!--					class="flex items-center text-[18px] cursor-pointer"-->
				<!--				>-->
				<!--					rss_feed-->
				<!--				</mat-icon>-->
				<svg [ngClass]="{ 'text-portals-primary-900': drawer, 'text-white': !drawer }" class="w-4 h-4 cursor-pointer dark:text-white mr-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
					<path d="M10 0C4.612 0 0 5.336 0 7c0 1.742 3.546 7 10 7 6.454 0 10-5.258 10-7 0-1.664-4.612-7-10-7Zm0 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" />
				</svg>
				Show Feed
			</a>
		</div>
	</div>
</div>
